export const setSettings = (settings) => {
  if (settings && settings instanceof Object) {
    localStorage.localSettings = JSON.stringify(settings);
  }
};

export const getSettings = () => {
  let settings = {};
  try {
    const localSettings = localStorage.localSettings;
    settings = JSON.parse(localSettings);
  } catch (e) {
    settings = {};
  }

  return settings;
};

export const setSettingByKey = (key, value) => {
  if (key) {
    const settings = getSettings();
    setSettings({
      ...settings,
      [key]: value,
    });
  }
};

export const getSettingByKey = (key) => {
  const settings = getSettings();
  return settings[key];
};



// WEBPACK FOOTER //
// ./src/utils/localSettings.js